var isagenix = {};

if(!isagenix.DropDownInator) {
    isagenix.DropDownInator = function (thisElement) {
        this.$element = $(thisElement);
        this.Id = this.$element.attr('id');

        this.matchingSku = function (optionSkus, groupSkus) {
            if(groupSkus.length === 0) {
                // just return the option sku
                return optionSkus[0];
            }

            var sku = '';
            optionSkus.sort();
            groupSkus.sort();
            for (var i = 0; i < optionSkus.length; i++) {
                if($.inArray(optionSkus[i], groupSkus) > -1) {
                    sku = (optionSkus[i]);
                    break;
                }
            }

            return sku;
        };

        this.findPrice = function (productId) {
            var pricing = this.$element.find('input[name="ProductPricing"]').val();
            pricing = JSON.parse(pricing);
            var buyNowPrice = '';
            var buyNowTax = '';
            var buyNowTotal = '';

            var signUpPrice = '';
            var signUpTax = '';
            var signUpTotal = '';

            var subscriptionPrice = '';
            var subscriptionTax = '';
            var subscriptionTotal = '';

            var subscriptionMessage = '';
            var subscriptionTooltip = '';
            var subscriptionDisclaimer = '';
            var preferredCustomerMessage = '';
            var signUpTooltip = '';

            for (var i = 0; i < pricing.length; i++) {
                if(pricing[i]['ProductId'] === productId) {
                    buyNowPrice = (pricing[i]['BuyNowPrice']);
                    buyNowTax = (pricing[i]['BuyNowTax']);
                    buyNowTotal = (pricing[i]['BuyNowTotal']);
                    signUpPrice = (pricing[i]['SignUpPrice']);
                    signUpTax = (pricing[i]['SignUpTax']);
                    signUpTotal = (pricing[i]['SignUpTotal']);
                    subscriptionPrice = (pricing[i]['SubscriptionPrice']);
                    subscriptionTax = (pricing[i]['SubscriptionTax']);
                    subscriptionTotal = (pricing[i]['SubscriptionTotal']);
                    subscriptionMessage = (pricing[i]['SubscriptionMessage']);
                    subscriptionTooltip = (pricing[i]['SubscriptionTooltipLabel']);
                    subscriptionDisclaimer = (pricing[i]['SubscriptionDisclaimer']);
                    preferredCustomerMessage = (pricing[i]['PreferredCustomerMessage']);
                    signUpTooltip = (pricing[i]['SubscribeNowLabel']);
                    break;
                }
            }

            this.$element.find('.buy-now-price').text(buyNowPrice);
            this.$element.find('.buy-now-tax').text(buyNowTax);
            this.$element.find('.buy-now-total').text(buyNowTotal);

            this.$element.find('.sign-up-price').text(signUpPrice);
            this.$element.find('.sign-up-tax').text(signUpTax);
            this.$element.find('.sign-up-total').text(signUpTotal);

            this.$element.find('.subscription-price').text(subscriptionPrice);
            this.$element.find('.subscription-tax').text(subscriptionTax);
            this.$element.find('.subscription-total').text(subscriptionTotal);

            var showSubscriptionPrice = this.$element.find('input[name="ShowSubscriptionPrice"]').val();
            if(showSubscriptionPrice === 'True' || showSubscriptionPrice === 'true') {
                this.$element.find('#div-subscription-message').html(subscriptionMessage);
                this.$element.find('#span-subscription-tooltip').text(subscriptionTooltip);
                this.$element.find('#div-subscription-tooltip-container').attr('data-title', subscriptionDisclaimer);
                this.$element.find('#div-preferredCustomer-message').html(preferredCustomerMessage);
                this.$element.find('#span-pc-tooltip').text(signUpTooltip);
            }
        };

        this.findSku = function (sku) {
            if(sku === undefined) {
                var optionSkus = this.$element.find("input:radio[name='flavor']:checked").val().split(',');
                var groupSkus = this.$element.find("input:radio[name='packaging']:checked").val().split(',');
                var packagName = this.$element.find("input:radio[name='packaging']:checked").attr('data-package-name');
                $('#packaging__selected').text(packagName);
                sku = this.matchingSku(optionSkus, groupSkus);
            }

            // set some hidden fields
            this.$element.find('div.product-sku span.sku').text(sku);
            this.$element.find('input[name="ProductId"]').val(sku).trigger('productChange');
            var productName = $('h2.product-name').text();
            this.$element.find('input[name="ProductName"]').val(productName);

            postProductDetails(sku, productName);

            // set the image based on the sku
            var slides = $('div.orbit-slide');
            var foundSlide = false;
            slides.each(function () {
                if(!foundSlide) {
                    var slide = $(this);
                    if(slide.data('sku').toString().indexOf(sku) > -1) {
                        $('div.orbit').foundation('changeSlide', false, slide, slide.data('slide'));
                        foundSlide = true;
                    }
                }
            });

            if(!foundSlide && slides.length > 0) {
                let defaultSlide = slides.first();
                $('div.orbit').foundation('changeSlide', false, defaultSlide, defaultSlide.data('slide'));
            }

            if(!foundSlide && slides.length > 0) {
                let defaultSlide = slides.first();
                $('div.orbit').foundation('changeSlide', false, defaultSlide, defaultSlide.data('slide'));
            }

            if(!foundSlide && slides.length > 0) {
                let defaultSlide = slides.first();
                $('div.orbit').foundation('changeSlide', false, defaultSlide, defaultSlide.data('slide'));
            }

            setFormValid(this.$element);
            this.findPrice(sku);
            this.displayDietaryIcon(sku);
            this.displayNutritionTab(sku);
        };

        this.filterGroupOptions = function () {
            var self = this;

            var temporarilyUnavailableMessage = self.$element.find('.temporarily-unavailable-message').text();

            var ddlFlavor = this.$element.find("input:radio[name='flavor']:checked");
            if(ddlFlavor.length === 0) return;

            var ddlPackaging = this.$element.find("input:radio[name='packaging']");
            if(ddlPackaging.length === 0) {
                // only one set of options...find the sku and dump out
                this.findSku(ddlFlavor.val());
                return;
            }

            // reset group selection every time ddlFlavor changes
            ddlPackaging.each(function () {
                var $this = $(this);
                $this.prop('checked', false);
                $this.parent().removeClass('selected-packaging'); // de-select all
            });

            this.$element.find('div.product-sku span.sku').text(''); // reset the SKU label too
            this.$element.find('input[name="ProductId"]').val('');

            if(ddlFlavor.length === 0) {
                ddlPackaging.each(function () {
                    var $this = $(this);
                    $this.prop('disabled', true);
                    $this.parent().addClass('disabled-packaging');
                    $this.parent().parent().addClass('disabled-packaging-container');
                });

                return;
            }

            var selectedProducts = ddlFlavor.val().split(',');

            // enable the group options
            ddlPackaging.each(function () {
                var $this = $(this);
                $this.prop('disabled', false);
                $this.parent().removeClass('disabled-packaging');
                $this.parent().parent().removeClass('disabled-packaging-container');
                $this.parent().removeClass('unavailable-packaging');
                $this.closest('.packaging-selection-container').find('.temporarily-unavailable-packaging-message').remove();
            });

            ddlPackaging.each(function () {
                var foundIt = false;
                var unavailablePackaging = false;
                var $this = $(this);

                for (var i = 0; i < selectedProducts.length; i++) {
                    if($this.val().indexOf(selectedProducts[i]) >= 0) {
                        foundIt = true;

                        var $thisFlavorPackage = self.$element.find('.product-availability[data-id="' + selectedProducts[i] + '"]');
                        if($thisFlavorPackage.length === 1) {
                            unavailablePackaging = $thisFlavorPackage.attr('data-available') === 'false';
                        }
                    }
                }

                if(!foundIt) {
                    $this.prop('disabled', true);
                    $this.parent().addClass('disabled-packaging');
                    $this.parent().parent().addClass('disabled-packaging-container');
                }

                if(unavailablePackaging) {
                    $this.prop('disabled', true);
                    $this.parent().addClass('unavailable-packaging');
                    $this.closest('.packaging-selection-container').append('<span class="temporarily-unavailable-packaging-message">' + temporarilyUnavailableMessage + '</span>');
                }
            });
        };

        this.displayDietaryIcon = function (sku) {
            $('.dietary-icons').attr('style', 'display:none');
            if(sku === undefined) {
                sku = $('#ProductId').val();
            }
            $('.dietary-icons-' + sku).attr('style', 'display:flex');
        };

        this.displayNutritionTab = function (sku) {
            if($('.custom-tabs__main-container').length > 0) {
                if(sku === undefined) {
                    sku = $('#ProductId').val();
                }

                var title = $('#skuTitle-' + sku).val();
                var description = $('#description-' + sku).val();
                var unitofMeasure = $('#unitofMeasure-' + sku).val();
                var nutritionFactLink = $('#nutritionfact-' + sku).val();
                var fileSize = $('#nutritionfact-fileSize-' + sku).val();

                $('#nutrition-tab-title').html(title === undefined ? '' : title);
                $('#nutrition-tab-description').html(description === undefined ? '' : description);
                if(unitofMeasure !== undefined && unitofMeasure !== null && unitofMeasure !== '') {
                    $('#nutrition-tab-unitofMeasure').html(unitofMeasure);
                    $('#nutrition-tab-measurement').show();
                } else {
                    $('#nutrition-tab-measurement').hide();
                }
                if(nutritionFactLink !== undefined && nutritionFactLink !== null && nutritionFactLink !== '') {
                    $('.nutrition-tab-nutritionFact-Link').attr('href', nutritionFactLink);
                    $('#nutrition-tab-FileSize').html(fileSize === undefined ? '' : ' ' + fileSize);
                    $('#nutrition-tab-nutritionFact').show();
                } else {
                    $('#nutrition-tab-nutritionFact').hide();
                }
                $('#nutrition-tab-dietaryIcon').html($('#divDietaryIcons').html());
            }
        };

        return {
            $element: this.$element,
            Id: this.Id,
            filterGroupOptions: this.filterGroupOptions,
            findSku: this.findSku,
            matchingSku: this.matchingSku,
            findPrice: this.findPrice,
            displayDietaryIcon: this.displayDietaryIcon,
            displayNutritionTab: this.displayNutritionTab
        };
    };
}

function initEventHandlers() {
    var $forms = $('.add-to-cart-form');
    var ddInator = {};

    var skuFromQueryString = getQueryStringValue('sku');

    $forms.each(function () {
        var $this = $(this);
        var thisId = $this.attr('id');

        if(!ddInator[thisId]) {
            ddInator[thisId] = new isagenix.DropDownInator($this);

            var hasPackagingOption = $this.find("input:radio[name='packaging']").length > 0;
            var $flavorSelect = $this.find("input:radio[name='flavor']");
            var $packageSelect = $this.find("input:radio[name='packaging']");
            var $purchaseSelect = $this.find("input:radio[name='purchase']");
            var $orbitImages = $('.orbit-bullets button');
            var $slideImages = $('.orbit-slide');
            var $revealImages = $('.reveal.overlay-image');

            $flavorSelect.on('change', function () {
                setFormInvalid($this);

                var thisFlavorRadio = $(this);
                ddInator[thisId].filterGroupOptions();

                $('label.flavor-selection').removeClass('selected-flavor');
                thisFlavorRadio.parent().addClass('selected-flavor');

                $('.orbit-bullets button').show();
                $('.orbit-slide').attr('style', 'display:none');
                $('.orbit-bullets button').attr('style', 'display:none');
                $revealImages.hide();
                console.log('flavors: ' + thisFlavorRadio.val());
                var selectedProducts = thisFlavorRadio.val().split(',');
                var foundCarousel = false;
                var useNewCarousel = true;
                var foundOrbitImages = $orbitImages;
                for (var i = 0; i < selectedProducts.length; i++) {
                    if(useNewCarousel) {
                        foundOrbitImages = $orbitImages.filter('[shared-sku*=true],[data-sku*=' + selectedProducts[i] + ']');
                    }

                    if(foundOrbitImages.length > 0) {
                        if(!foundCarousel) {
                            foundOrbitImages.each(function (index, el) {
                                if(!foundCarousel) {
                                    $slideImages.filter('[data-sku*=' + $(el).attr('data-sku') + ']').first().show();
                                    $(el).trigger('click');
                                    foundCarousel = true;
                                }
                            });
                        }
                        foundOrbitImages.show();
                    }
                }

                if(!foundCarousel) {
                    if($slideImages.length > 1) {
                        $slideImages.first().show();
                    } else {
                        $slideImages.filter('[data-sku*=DefaultProductImage]').show();
                    }
                }

                if(hasPackagingOption) {
                    $this.find('.buy-now-price').css({ 'opacity': '0.3' });
                    $this.find('.buy-now-total').css({ 'opacity': '0.3' });
                    $this.find('.sign-up-price').css({ 'opacity': '0.3' });
                    $this.find('.sign-up-total').css({ 'opacity': '0.3' });
                    $this.find('.subscription-price').css({ 'opacity': '0.3' });
                    $this.find('.subscription-total').css({ 'opacity': '0.3' });
                } else {
                    $this.find('.buy-now-price').css({ 'opacity': '0' }).animate({ 'opacity': '1' }, 500);
                    $this.find('.buy-now-total').css({ 'opacity': '0' }).animate({ 'opacity': '1' }, 500);
                    $this.find('.sign-up-price').css({ 'opacity': '0' }).animate({ 'opacity': '1' }, 500);
                    $this.find('.sign-up-total').css({ 'opacity': '0' }).animate({ 'opacity': '1' }, 500);
                    $this.find('.subscription-price').css({ 'opacity': '0' }).animate({ 'opacity': '1' }, 500);
                    $this.find('.subscription-total').css({ 'opacity': '0' }).animate({ 'opacity': '1' }, 500);
                }

                if(this.value !== '' && $packageSelect.length > 0) {
                    var counter = 0;
                    var disabledCounter = 0;
                    var activeIndex = 0;
                    var firstActiveIndex = 0;
                    var activeCounter = 0;
                    $packageSelect.each(function (index, el) {
                        if($(el).prop('disabled') === true) {
                            disabledCounter++;
                        } else {
                            activeIndex = index;
                            if(activeCounter === 0) {
                                firstActiveIndex = index;
                            }
                            activeCounter++;
                        }

                        counter++;
                    });

                    $this.filter('.hide-single-packaging-options').find('.product-variation.packaging').removeClass('hide');
                    if(counter - disabledCounter === 1) {
                        $this.filter('.hide-single-packaging-options').find('.product-variation.packaging').addClass('hide');
                        var singlePackageOption = $('#' + $packageSelect[activeIndex].id);
                        singlePackageOption.trigger('click');
                    } else if(activeCounter > 1) {
                        $('#' + $packageSelect[firstActiveIndex].id).trigger('click');
                    }
                }
                ddInator[thisId].displayDietaryIcon();
                ddInator[thisId].displayNutritionTab();
            });

            $packageSelect.on('change', function () {
                var thisPackagingRadio = $(this);

                $('label.packaging-selection').removeClass('selected-packaging');
                thisPackagingRadio.parent().addClass('selected-packaging');

                $this.find('.buy-now-price').css({ 'opacity': '0' }).animate({ 'opacity': '1' }, 500);
                $this.find('.buy-now-total').css({ 'opacity': '0' }).animate({ 'opacity': '1' }, 500);
                $this.find('.sign-up-price').css({ 'opacity': '0' }).animate({ 'opacity': '1' }, 500);
                $this.find('.sign-up-total').css({ 'opacity': '0' }).animate({ 'opacity': '1' }, 500);
                $this.find('.subscription-price').css({ 'opacity': '0' }).animate({ 'opacity': '1' }, 500);
                $this.find('.subscription-total').css({ 'opacity': '0' }).animate({ 'opacity': '1' }, 500);
                ddInator[thisId].findSku();

                var optionSkus = $("input:radio[name='flavor']:checked").val().split(',');
                var hdnSlides = [];
                $('.orbit-slide').each(function (index) {
                    var dataSku = $(this).attr('data-sku');
                    var sharedSKU = $(this).attr('shared-sku');
                    var slideNo = $(this).attr('data-slide');
                    if(slideNo === undefined) {
                        slideNo = index;
                    }
                    if(sharedSKU !== 'true') {
                        for (const optionSku of optionSkus) {
                            if(dataSku.includes(optionSku)) {
                                if(hdnSlides.indexOf(slideNo) === -1) {
                                    hdnSlides.push(slideNo);
                                }
                            }
                        }
                    } else {
                        if(hdnSlides.indexOf(slideNo) === -1) {
                            hdnSlides.push(slideNo);
                        }
                    }
                    if($(this).hasClass('is-active')) {
                        $('#upClickSlide').attr('data-current-slide', slideNo);
                        $('#downClickSlide').attr('data-current-slide', slideNo);
                    }
                });
                if(hdnSlides.length > 0) {
                    $('#hdnSlides').val(hdnSlides.toString());
                }
            });

            $packageSelect.each(function () {
                $(this).prop('disabled', true);
                $(this).parent().addClass('disabled-packaging');
                $(this).parent().parent().addClass('disabled-packaging-container');
            });

            if($flavorSelect.length === 1) {
                // there's only one flavor option, so select it
                var singleFlavorOption = $('#' + $flavorSelect[0].id);
                singleFlavorOption.trigger('click');
            }

            // only one flavor or no flavour available, then envoke displayNutritionTab function for toggle the tabs and displayDietaryIcon
            if($flavorSelect.length === 0) {
                ddInator[thisId].displayNutritionTab();
                ddInator[thisId].displayDietaryIcon();
                var productName = $('h2.product-name').text();
                var sku = $('#ProductId').val();
                postProductDetails(sku, productName);
            }

            if($packageSelect.length === 1) {
                // there's only one package option, so select it
                var singlePackageOption = $('#' + $packageSelect[0].id);
                singlePackageOption.trigger('click');
            }

            $purchaseSelect.on('change', function () {
                $('label.purchase-selection').removeClass('selected-purchase');
                $('div.price-box').removeClass('selected-price-box');
                $(this).parent().parent().parent().addClass('selected-price-box');
                $(this).parent().parent().addClass('selected-purchase'); // radio is nested in a <div> now
                $(this).parent().parent().parent().find('.price-details-section').addClass('selected-purchase-section'); // radio is nested in a <div> now

                if($('#rdoSubscribe').prop('checked')) {
                    $('#SingleQuantity').val('1');
                    // $('#pc-quantity-selector').show();
                    $('.pc-price-tooltip-container').show();
                    // $('#retail-quantity-selector').hide();
                    // $('#subscription-quantity-selector').hide();
                    $('.subscription-price-tooltip-container').hide();
                } else if($('#rdoSubscription').prop('checked')) {
                    $('#SingleQuantity').val('1');
                    // $('#pc-quantity-selector').hide();
                    $('.pc-price-tooltip-container').hide();
                    // $('#retail-quantity-selector').hide();
                    // $('#subscription-quantity-selector').show();
                    $('.subscription-price-tooltip-container').show();
                } else {
                    $('.pc-price-tooltip-container').hide();
                    $('#SingleQuantity').val('1');
                    // $('#pc-quantity-selector').hide();
                    // $('#retail-quantity-selector').show();
                    // $('#subscription-quantity-selector').hide();
                    $('.subscription-price-tooltip-container').hide();
                }
            });

            var useSkuFromQueryString = false;
            if(skuFromQueryString && skuFromQueryString.length > 0) {
                // we're passing in a sku in the query string to select a specific product...find it and select it
                var foundFlavor = $flavorSelect.filter('[value*=' + skuFromQueryString + ']');
                if(foundFlavor.length > 0) {
                    useSkuFromQueryString = true;
                    var foundFlavorObject = $('#' + foundFlavor[0].id);
                    foundFlavorObject.trigger('click');
                }

                if(useSkuFromQueryString && hasPackagingOption) {
                    var foundPackage = $packageSelect.filter('[value*=' + skuFromQueryString + ']');
                    var foundPackageObject = $('#' + foundPackage[0].id);
                    foundPackageObject.trigger('click');
                }
            }

            if(!useSkuFromQueryString) {
                // default to first flavor option
                if($flavorSelect.length > 0) {
                    $('#flavor-0').trigger('click');
                }
            }

            // default to subscribe if it exists
            if($purchaseSelect.length > 0) {
                if($('#rdoSubscription').length > 0) {
                    $('#rdoSubscription').trigger('click');
                } else {
                    $('#rdoSubscribe').trigger('click');
                }
            }

            if(useSkuFromQueryString) {
                // can't call this earlier or else the subscribe option won't get selected for some reason
                // this.findSku.call(this, skuFromQueryString);
                ddInator[thisId].findSku(skuFromQueryString);
            }
        }
    });

    // set the image based on the sku
    var slides = $('div.orbit-slide').filter(function () {
        if($(this).css('display') === 'block') { return $(this); }
    });
    if(slides.length > 0) {
        var slide = slides.first();
        $('div.orbit').foundation('changeSlide', false, slide, slide.data('slide'));
    }

    $('.add-to-cart-handleFormSubmit').on('click', handleFormSubmit);
}

function setFormInvalid($element) {
    $element.addClass('invalid');
}

function setFormValid($element) {
    $element.removeClass('invalid');
}

function isFormValid($element) {
    return $element.is('.invalid');
}

function handleFormSubmit() {
    var isSignUp = 2;
    var formId = $('#hdnFormId').val();
    var $form = $('#' + formId);
    if(isFormValid($form)) return;

    var flavorOptionRadio = $("input:radio[name='flavor']");
    var selectedFlavor = $("input:radio[name='flavor']:checked");
    if(flavorOptionRadio.length > 0 && selectedFlavor.length <= 0) {
        $('#optSelectError').foundation('open');
        return;
    }

    var packagingOptionRadio = $("input:radio[name='packaging']");
    var selectedPackaging = $("input:radio[name='packaging']:checked");
    if(packagingOptionRadio.length > 0 && selectedPackaging.length <= 0) {
        $('#optSelectError2').foundation('open');
        return;
    }

    if(isSignUp === 2) {
        // subscribe or retail
        isSignUp = $('#rdoSubscribe').prop('checked') ? 1 : ($('#rdoSubscription').prop('checked') ? 2 : 0);
    }

    var actionType = isSignUp === 1 ? 'signup' : isSignUp === 2 ? 'subscription' : 'buynow';
    $('#ActionType').val(actionType);

    // Getting quantity based on PreferredCustomer/Retail from respective container
    var quantity = $('#SingleQuantity').val() || 1;
    var signUpQuantity = isSignUp === 1 ? quantity : 0;
    var subscriptionQuantity = isSignUp === 2 ? quantity : 0;
    var buyNowQuantity = (signUpQuantity + subscriptionQuantity) === 0 ? quantity : 0;
    var isInfoPage = $('#single-quantity-selector').attr('data-is-infomercial-page');

    var url = $form.attr('action') + '?' +
        'ctx=' + $form.attr('ctx') +
        '&sku=' + $('#ProductId').val() +
        '&actionType=' + actionType +
        '&BuyNowQuantity=' + buyNowQuantity +
        '&SignUpQuantity=' + signUpQuantity +
        '&SubscriptionQuantity=' + subscriptionQuantity;

    if(isInfoPage !== undefined && isInfoPage === 'True') {
        url += '&IsInfoPage=true';
    } else {
        url += '&IsInfoPage=false';
    }

    window.open(url, $form.attr('target'));
}

function getQueryStringValue(key) {
    var qs = window.location.search.substring(1).split('&');
    for (var i = 0; i < qs.length; i++) {
        var keyValuePairs = qs[i].split('=');
        if(keyValuePairs[0] === key) return keyValuePairs[1];
    }
    return '';
}

function postProductDetails(sku, productName) {
    var body = document.body;
    var html = document.documentElement;

    var height = Math.max(body.scrollHeight, body.offsetHeight,
        html.clientHeight, html.scrollHeight, html.offsetHeight);

    console.log('Iframe Height Posted', height);
    var bpMessage = '{ "ProductId":"' + sku + '", "sku":"' + sku + '", "ProductUrl":"' + window.location.href + '", "ProductImageUrl":"' + $('#ProductImageUrl').val() + '", "ProductDisplayName":"' + productName + '", "WindowHeight":"' + height + '" }';
    window.parent.postMessage(bpMessage, '*');
}

$(function () {
    initEventHandlers();
});
